import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-notice-list',
  templateUrl: './notice-list.component.html',
  styleUrls: ['./notice-list.component.scss']
})
export class NoticeListComponent implements OnInit {
  vendorID:string;
  noticeList:[];

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService) { 
      this.vendorID = this.activatedRoute.snapshot.paramMap.get('vendorID');

    }

  ngOnInit() {

    let noticeData = {
      token:localStorage.getItem("token_data"),
      userID:localStorage.getItem("userID"),
      vendorID:this.vendorID
    }

    this.apiService.noticeList(noticeData).subscribe((res:any)=>{
      
      this.noticeList = res.data.vendorNoticeList;
      

  },async err => {
     
  })
  }

  Details(noticeID){    
    this.router.navigateByUrl(`notice-details/` + noticeID);
  }

}
